import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class GridDateLocaleDateFormatter extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}
	formatDate = (date_string) => {
		var dt = new Date(Date.parse(date_string)).toLocaleString();
		return (new Date(dt).getMonth() + 1) + "/" + new Date(dt).getDate() + "/" + new Date(dt).getFullYear();
	}

	render() {
		return (
			<td colSpan={this.props.colSpan} style={this.props.style}>
				{
					this.props.dataItem[this.props.field] != null ?
						this.formatDate(this.props.dataItem[this.props.field])
						: ''
				}
			</td>
		);
	}
}
export default withRouter(connect(
)(GridDateLocaleDateFormatter));